import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProductState {
  id: any;
  name: any;
  category: any;
  categoryId: any;
  price: any;
  description: any;
  manufacturer: any;
  productId: any;
  stock: any;
  imageLink: any;
  version: any;
  props: {
    [key: string]: any;
  };
}

const initialState: ProductState = {
  id: '',
  name: '',
  category: '',
  categoryId: '',
  price: '',
  description: '',
  manufacturer: '',
  productId: '',
  stock: '',
  imageLink: '',
  version: '',

  props: { isModalVisible: false, refresh: false, isFinish: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setProduct: (state, action: PayloadAction<Partial<ProductState>>) => {
      return { ...state, ...action.payload };
    },

    resetProduct: (_state, action: PayloadAction<Partial<ProductState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateField: (state: ProductState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const { setProduct, resetProduct, updateField, updateProps } = productSlice.actions;

export default productSlice.reducer;
